"use client";

export { PhiNextGlobalErrorPage as default } from "@phis/ui/next/global-error";
